import React from 'react';
import './VersionBanner.scss';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import useVersionCheck from '../../hooks/global/useVersionCheck';

const VersionBanner: React.FC = () => {
  const { t } = useTranslation();
  const newVersionAvailable = useVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <div className="version-toast">
      <span className="version-toast__text">{t('newVersionAvailable')}</span>
      <Button
        className="version-toast__btn btn btn-primary btn--xxs"
        label={t('refresh')}
        type="button"
        onClick={() => window.location.reload()}
      />
    </div>
  );
};

export default VersionBanner;
